export const SPOTIFY_FALLBACK = {
  artist: {
    id: import.meta.env.VITE_SPOTIFY_ARTIST_ID || '',
    name: 'A5omic',
    images: [
      {
        url: '/profile.jpg',
        height: 640,
        width: 640
      }
    ],
    followers: {
      total: 6231
    }
  },
  tracks: [
    {
      id: '15jySYm1cu72XRNXzGLLpv',
      name: 'Only Place To Go From Failure',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273126d1e0de0b3b0e87e0e5fb0', height: 640, width: 640 }],
        name: 'Only Place To Go From Failure',
        release_date: '2025-10-24'
      },
      duration_ms: 108533,
      preview_url: null
    },
    {
      id: '5fuHOcJlNWmJWb956EFrGI',
      name: 'You Have Execute Authority',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273f9b7e69016f9aa65b05975ca', height: 640, width: 640 }],
        name: 'You Have Execute Authority',
        release_date: '2025-09-16'
      },
      duration_ms: 113033,
      preview_url: null
    },
    {
      id: '14xUUPyqwjWDXzEWtv2BIu',
      name: 'You Must Own Your Mind',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273c3dc3d48fd6406df322fbfcd', height: 640, width: 640 }],
        name: 'You Must Own Your Mind',
        release_date: '2026-01-23'
      },
      duration_ms: 136666,
      preview_url: null
    },
    {
      id: '5lNaPRBMpUysN4XHcJyNi7',
      name: 'I Am What The World Forged',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273f8d838f1b07b0876461fb184', height: 640, width: 640 }],
        name: 'I Am What The World Forged',
        release_date: '2025-07-11'
      },
      duration_ms: 170600,
      preview_url: null
    },
    {
      id: '5y2AGHV9Gwilj2aDZhplVZ',
      name: "They Ain't Tough",
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273f8d4ffea182ce42b95e5428c', height: 640, width: 640 }],
        name: "They Ain't Tough",
        release_date: '2024-12-19'
      },
      duration_ms: 97916,
      preview_url: null
    },
    {
      id: '175DuBRjjJq4yGDaWYQ9co',
      name: 'I Wish The Water Was COLD',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273c9d687b729553343d6b10822', height: 640, width: 640 }],
        name: 'I Wish The Water Was COLD',
        release_date: '2025-10-31'
      },
      duration_ms: 126100,
      preview_url: null
    },
    {
      id: '4sx0RNLLIGBVqYFEu3DhP4',
      name: 'The One || The Only',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273ce447b682a8ed35802ea64c0', height: 640, width: 640 }],
        name: 'The One || The Only',
        release_date: '2024-07-01'
      },
      duration_ms: 151550,
      preview_url: null
    },
    {
      id: '6s5jjw7U8HlP0fGodIpfOx',
      name: 'The Honored One',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273a6b27a178eda2904c65c6c04', height: 640, width: 640 }],
        name: 'The Honored One',
        release_date: '2024-04-08'
      },
      duration_ms: 110550,
      preview_url: null
    },
    {
      id: '3bvBcJK6Hrn3roMStZ3eUU',
      name: "I'm Tired Alfred",
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b27333afaf6033e8fd81dcb3dffa', height: 640, width: 640 }],
        name: "I'm Tired Alfred",
        release_date: '2025-12-12'
      },
      duration_ms: 122000,
      preview_url: null
    },
    {
      id: '6ByUnIQ6M8WvbqXoVwXsBn',
      name: 'Spartans What Is Your Profession',
      album: {
        images: [{ url: 'https://i.scdn.co/image/ab67616d0000b273c1594d0bfccee119e382b3d6', height: 640, width: 640 }],
        name: 'Spartans What Is Your Profession',
        release_date: '2024-08-27'
      },
      duration_ms: 81383,
      preview_url: null
    }
  ]
};
